<template>
  <div class="zj-login-page">
    <zj-login-carousel
      v-if="THM('login.carousel.visiable', true)" />
    <div class="zj-login-form-container">
      <zj-login-form
        :title="CNF('app.name', '')"
        @login="onLogin" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZjLogin',
  methods: {
    // 登录成功
    onLogin(user) {
      this.$emit('login', user)
    }
  }

}
</script>
